// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const billingStorageUsageDto = {
    day: 'day',
    bytes: 'bytes',
} as const;

export type TBillingStorageUsageDto = (typeof billingStorageUsageDto)[keyof typeof billingStorageUsageDto];

export interface IBillingStorageUsageDto {
    [billingStorageUsageDto.day]: string | null;
    [billingStorageUsageDto.bytes]: number | null;
}

export class BillingStorageUsageDto
    implements IBillingStorageUsageDto
{
    [billingStorageUsageDto.day]: string | null = null;
    [billingStorageUsageDto.bytes]: number | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IBillingStorageUsageData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[billingStorageUsageDto.guid] = modelData[billingstorageusageData.guid];
    }

    static create(modelData?: any | null): IBillingStorageUsageDto | null {
        return modelData ? new BillingStorageUsageDto(modelData) : null;
    }
}
